<template>
  <div class="w-full recaptcha-container">
    <div class="w-full g-recaptcha" :data-sitekey="siteKey" ref="recaptcha"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';

export default {
  name: 'ReCaptcha',
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    let widgetId = null;
    const recaptcha = ref(null);

    function renderRecaptcha() {
      if (widgetId !== null) return;

      widgetId = window.grecaptcha.render(recaptcha.value, {
        callback: (response) => {
          emit('verified', response);
        },
        'expired-callback': () => {
          emit('expired');
        },
      });
    }

    function waitForRecaptchaReady(callback) {
      const check = () => {
        if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
          callback();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    }

    onMounted(() => {
      waitForRecaptchaReady(renderRecaptcha);
    });


    onBeforeUnmount(() => {
      if (widgetId !== null) {
        grecaptcha.reset(widgetId)
        widgetId = null
      }
    });

    return {
      recaptcha,
    };
  },
};
</script>

<style scoped>
/* .recaptcha-container {
  display: flex;
  margin-top: 10px;
} */
.g-recaptcha {
  display: block;
  margin: auto;
}
</style>